<div class="toaster-container">
  @for (toast of toasts(); track toast.id) {
    <div class="toast-item" [class]="toast.type" (click)="(!toast.onAccept && !toast.onDecline) ? dismiss(toast.id) : null">
      <div class="toast-content-wrapper">
        <div class="d-flex align-items-center gap-3">
          @if (toast.imageUrl) {
            <img [src]="toast.imageUrl" class="toast-image rounded-circle border border-2 border-secondary" width="40" height="40" style="object-fit: cover;" alt="Toast Icon">
          }
          <div class="toast-content">
            {{ toast.message }}
          </div>
        </div>
        @if (toast.onAccept || toast.onDecline) {
          <div class="toast-actions">
            @if (toast.onAccept) {
              <button class="btn btn-toast-accept" (click)="$event.stopPropagation(); toast.onAccept(); dismiss(toast.id)">Accept</button>
            }
            @if (toast.onDecline) {
              <button class="btn btn-toast-decline" (click)="$event.stopPropagation(); toast.onDecline(); dismiss(toast.id)">Decline</button>
            }
          </div>
        }
      </div>
      <button class="toast-close" (click)="$event.stopPropagation(); (toast.onDecline ? toast.onDecline() : null); dismiss(toast.id)">&times;</button>
    </div>
  }
</div>
